/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordWithLinks } from "./RecordWithLinks";
export const RecordsWithLinks = core.serialization.list(RecordWithLinks);
